export const NexusMutualStakingEvents = {
  GetStakerContractsArray: 'NexusMutualStaking.StakerContractsArray',
  StakerContractsArrayReturned:
    'NexusMutualStaking.StakerContractsArrayReturned',

  GetStakerContractStake: 'NexusMutualStaking.StakerContractStake',
  StakerContractStakeReturned: 'NexusMutualStaking.StakerContractStakeReturned',
}
